import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #10274d, #153e6f);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Card = styled.div`
  background: #002e5d;
  color: white;
  padding: 2.5rem 2rem;
  max-width: 400px;
  width: 100%;
  border-radius: 20px;
  text-align: center;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.7rem 0.9rem;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
`;

const Button = styled.button`
  width: 100%;
  background-color: white;
  color: #002e5d;
  padding: 0.75rem;
  border: none;
  border-radius: 999px;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background-color: #f3f4f6;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const BackLink = styled(Link)`
  font-size: 0.9rem;
  margin-top: 1.5rem;
  color: white;
  text-decoration: underline;
  cursor: pointer;
`;


const Icon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(""); // Clear any previous errors
    setLoading(true);

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    try {
        await fetch("https://6l7xr03tz5.execute-api.us-east-1.amazonaws.com/prod/request-reset", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
        });

        // Always show success for valid email format to prevent enumeration
        setSubmitted(true);
    } catch (err) {
        console.error("Reset request failed:", err);
        // Still show success to prevent enumeration
        setSubmitted(true);
    } finally {
        setLoading(false);
    }
    };


  return (
    <Page>
      <Card>
        <img src="/images/skroop_white_transparent_thick.png" alt="Skroop logo" style={{ height: "200px", marginBottom: "0.5rem" }} />

            <h2 style={{ fontSize: "2rem", fontWeight: "600", marginBottom: "1.5rem" }}>
            Forgot Your Password?
            </h2>
            <p style={{ fontSize: "0.95rem", lineHeight: 1.5, marginBottom: "1.5rem" }}>
            Enter your email address and we will send you instructions to reset your Skroop password.
            </p>


        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <Input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button type="submit" disabled={loading}>
              {loading ? (
                <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                  <span style={{ 
                    width: '16px', 
                    height: '16px', 
                    border: '2px solid #002e5d', 
                    borderTop: '2px solid transparent', 
                    borderRadius: '50%', 
                    animation: 'spin 1s linear infinite' 
                  }}></span>
                  Processing...
                </span>
              ) : (
                'Continue'
              )}
            </Button>
            
            <div style={{ marginTop: "1.25rem" }}>
            <   BackLink to="/login">Back</BackLink>
            </div>

                {error && (
                    <p style={{ color: 'salmon', fontSize: '0.9rem', marginTop: '0.75rem' }}>
                    {error}
                    </p>
                )}

          </form>
        ) : (
          <>
            <Icon>📧</Icon>
            <h2>Check Your Email</h2>
            <p>
              Please check the email address <strong>{email}</strong> for instructions to reset your password.
            </p>
            <BackLink to="/login">Back</BackLink>
          </>
        )}
      </Card>
    </Page>
  );
}